import settings from "../../configs/appSettings";

export const imageCdnUrls = {
    // icons
    back_arrow: `${settings.cdnUrl}/icons/back-arrow.svg`,
    caret_down_grey: `${settings.cdnUrl}/icons/caret-down-grey.svg`,
    caret_up_grey: `${settings.cdnUrl}/icons/caret-up-grey.svg`,
    checkmark_circle: `${settings.cdnUrl}/icons/checkmark-circle.svg`,
    comm_add_group: `${settings.cdnUrl}/icons/comm-add-group.svg`,
    comm_add_list: `${settings.cdnUrl}/icons/comm-add-list.svg`,
    comm_add_map: `${settings.cdnUrl}/icons/comm-add-map.svg`,
    comm_associate_event: `${settings.cdnUrl}/icons/comm-associate-event.svg`,
    comm_email: `${settings.cdnUrl}/icons/comm-email.svg`,
    comm_text: `${settings.cdnUrl}/icons/comm-text.svg`,
    comm_voice: `${settings.cdnUrl}/icons/comm-voice.svg`,
    communications: `${settings.cdnUrl}/icons/communications.svg`,
    date_picker: `${settings.cdnUrl}/icons/date-picker.svg`,
    date_picker_blue: `${settings.cdnUrl}/icons/date-picker-blue.svg`,
    download: `${settings.cdnUrl}/icons/download.svg`,
    ellipsis: `${settings.cdnUrl}/icons/3-dots.svg`,
    exclamation_circle: `${settings.cdnUrl}/icons/exclamation-circle.svg`,
    filter: `${settings.cdnUrl}/icons/filter.svg`,
    map_marker: `${settings.cdnUrl}/icons/`,
    map_marker_png: `${settings.cdnUrl}/pngs/map-marker-unselected-01.png`,
    radio_unselected: `${settings.cdnUrl}/icons/radio-unselected.svg`,
    users: `${settings.cdnUrl}/icons/users.svg`,
    x_red: `${settings.cdnUrl}/icons/x-red.svg`,
    hurricane: `${settings.cdnUrl}/icons/hurricane.svg`,
    hurricane_white: `${settings.cdnUrl}/icons/hurricane-white.svg`,
    wildfire: `${settings.cdnUrl}/icons/wildfire.svg`,
    wildfire_white: `${settings.cdnUrl}/icons/wildfire-white.svg`,
    virus: `${settings.cdnUrl}/icons/covid.svg`,
    virus_white: `${settings.cdnUrl}/icons/covid-white.svg`,

    //illustrations
    complete_initiative: `${settings.cdnUrl}/illustrations/complete-initiative.svg`,
    new_user: `${settings.cdnUrl}/illustrations/new-user.svg`,
    x_error: `${settings.cdnUrl}/illustrations/x-error.svg`,

    //loading animations
    small_loader: `${settings.cdnUrl}/loading-animations/small-loader.gif`,

    //logos
    logoContractsBlue: `${settings.cdnUrl}/logos/logo-contracts-blue.svg`,
    nLogoGrey: `${settings.cdnUrl}/logos/logo-grey.svg`,
};
